import * as API from './api'
import * as Types from './Types'
import * as Constants from '../../helpers/Constants'
import * as Strings from './strings'

export function tryCreatePost(token, communityId, data, onSuccess, alert) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_POST
    })

    API.createPost(token, communityId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_POST_SUCCESS,
          payload: response.data.data
        })

        onSuccess()
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.CREATE_POST_FAILED,
          payload: status
        })

        alert(
          Strings.default.INTERNAL_ERROR_HEADER,
          Strings.default.INTERNAL_ERROR,
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK,
            onPress: () => {}
          }
        )
      })
  }
}

export function tryDeletePost(token, communityId, postId, alert) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_POST
    })

    API.deletePost(token, communityId, postId)
      .then(response => {
        dispatch({
          type: Types.DELETE_POST_SUCCESS,
          payload: postId
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.DELETE_POST_FAILED,
          payload: status
        })

        alert(
          Strings.default.INTERNAL_ERROR_HEADER,
          Strings.default.INTERNAL_ERROR,
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK,
            onPress: () => {}
          }
        )
      })
  }
}

export function tryDeleteComment(token, postId, commentId, alert) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_COMMENT
    })

    API.deleteComment(token, postId, commentId)
      .then(response => {
        dispatch({
          type: Types.DELETE_COMMENT_SUCCESS,
          payload: { postId, commentId }
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.DELETE_COMMENT_FAILED,
          payload: status
        })

        alert(
          Strings.default.INTERNAL_ERROR_HEADER,
          Strings.default.INTERNAL_ERROR,
          Constants.ONE_BUTTON,
          {
            title: Strings.default.OK,
            onPress: () => {}
          }
        )
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/NewsFeed.js